<template>
  <v-dialog v-model="show" width="600" persistent eager>
    <v-form autocomplete="off" @submit.prevent="submit">
      <v-card class="mx-auto" outlined>
        <v-card-title class="headline">
          Import Meal Guide from Google Sheet
        </v-card-title>

        <v-divider />

        <v-card-text class="py-5">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="form.google_sheet_id"
                label="Google Sheet ID or URL"
                placeholder="Enter Google Sheet ID or full URL"
                :error-messages="form.$getError('google_sheet_id')"
                :hide-details="!form.$getError('google_sheet_id')"
                outlined
                flat
              />
              <div class="text-caption grey--text mt-2">
                You can paste the full Google Sheet URL or just the sheet ID
              </div>
            </v-col>

            <v-col cols="12">
              <div class="text-subtitle-2 grey--text text--darken-2 mb-2">
                Add to categories
              </div>
              <v-autocomplete
                v-model="form.category_ids"
                :items="categories"
                :loading="loadingCategories"
                item-text="name"
                item-value="id"
                label="Select meal guide categories"
                placeholder="Select one or more categories"
                :error-messages="form.$getError('category_ids')"
                :hide-details="!form.$getError('category_ids')"
                multiple
                chips
                deletable-chips
                small-chips
                clearable
                outlined
                flat
              />
              <div class="text-caption grey--text mt-1">
                Imported guides will be added to each selected category
              </div>
            </v-col>

            <v-col cols="12" class="pt-0">
              <div class="text-subtitle-2 grey--text text--darken-2 mb-2">
                Post-Import Options
              </div>
              <v-checkbox
                v-model="form.clear_selected_categories"
                label="Clear the meal guides of the selected category"
                :disabled="!form.category_ids.length"
                hide-details
                class="mt-0"
              />
              <div class="text-caption grey--text mt-1">
                Removes existing meal guides from the selected categories before
                adding the imported ones
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions class="px-6 pb-6 pt-5">
          <v-spacer />

          <v-btn
            class="px-12 error--text"
            text
            @click="cancel"
            :disabled="form.$busy"
          >
            Cancel
          </v-btn>

          <v-btn
            class="primary px-12"
            text
            type="submit"
            :loading="form.$busy"
            :disabled="form.$busy"
          >
            Import
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Form from '@/utils/form'

export default {
  name: 'ImportMealGuideDialog',

  data() {
    return {
      show: false,
      categories: [],
      loadingCategories: false,
      form: new Form({
        google_sheet_id: '',
        clear_selected_categories: false,
        category_ids: [],
      }),
    }
  },

  methods: {
    open() {
      this.show = true
      this.form.$reset()
      this.fetchCategories()
    },

    async fetchCategories() {
      this.loadingCategories = true
      try {
        await this.$store.dispatch('mealGuideCategory/getDataList', {})
        this.categories = this.$store.state.mealGuideCategory.list.filter(
          (category) => category.is_active
        )
      } catch (error) {
        this.categories = []
      } finally {
        this.loadingCategories = false
      }
    },

    close() {
      this.show = false
    },

    submit() {
      this.$emit('submit', this.form)
    },

    cancel() {
      this.form.$reset()
      this.close()
    },
  },
}
</script>
